import React, { FC } from 'react';
import './TherapistSection.css';
import theraput2Image from '../../../assets/theraput2.webp';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { colors } from '../../../colors/Colors';
import { useLocalizedNavigate } from '../../../hooks/useLocalizedNavigate';

export const TherapistSection: FC = () => {
    const { t } = useTranslation();
    const navigate = useLocalizedNavigate();

    const navigateToForTherapists = () => {
        navigate('/for-therapists');
    };

    return (
        <section className="fortherapists" id="fortherapists">
            <div className="fortherapists_container container">
                <div className="fortherapists_content">
                    {/* h2, ne h1 — stranica sme da ima samo jedan h1 (hero u HomePage.tsx) */}
                    <h2 className="fortherapists_title">{t('home.section3.title')}</h2>
                    <p className="fortherapists_description">
                        <Trans
                            i18nKey="home.section3.text"
                            components={{ span: <span className="about__title--primary"></span> }}
                        />
                    </p>
                    <div className="fortherapists_button">
                        <Button
                            variant="contained"
                            style={{
                                backgroundColor: colors.primary,
                                borderRadius: '50px',
                                height: '50px',
                                width: '300px',
                                fontWeight: 'bold',
                                letterSpacing: '1px',
                            }}
                            size="large"
                            onClick={navigateToForTherapists}
                        >
                            {t('home.section3.button')}
                        </Button>
                    </div>
                </div>
                <div className="fortherapists_image">
                    <img src={theraput2Image} alt="Online psihoterapijska sesija — zakazivanje terapije na BalancePath platformi" loading="lazy" />
                </div>
            </div>
        </section>
    );
};
